import { baseApiRoutes } from '../../core/config/apiRoutes';

export const apiRoutes = {
  ...baseApiRoutes,
  employees: {
    get: 'employees/:id',
    getByVersion: 'employees/:id/version',
    getVersionOptions: 'employees/:id/version-options',
    getSimilarVersionOptions: 'employees/:id/similar-version-options',
    list: 'employees',
    create: 'employees',
    createAsDraft: 'employees/draft',
    update: 'employees/:id',
    updateAsDraft: 'employees/:id/draft',
    delete: 'employees/:id',
    rolesOptions: 'employees/role-options',
    genderOptions: 'employees/gender-options',
    options: 'employees/options',
    optionsForSignees: 'employees/options/signees',
    bulkDelete: 'employees/bulk-delete',
    getSchedule: 'employees/:id/schedule',
    updateSchedule: 'employees/:id/schedule',
    listAvailability: 'employees/availability',
    listAvailabilityForEmployee: 'employees/availability-for-employee',
  },
  documentTemplates: {
    get: 'document-templates/:id',
    list: 'document-templates',
    create: 'document-templates',
    update: 'document-templates/:id',
    delete: 'document-templates/:id',
    typesOptions: 'document-templates/type-options',
    getTypeVariables: 'document-templates/type-variables',
    getTypeVariablesForEmployee:
      'document-templates/type-variables-for-employee',
    getForAutoFill: 'document-templates/for-autofill',
    getForAutoFillForEmployee: 'document-templates/for-autofill-for-employee',
    options: 'document-templates/options',
    optionsByType: 'document-templates/:type/options',
    optionsByTypeForEmployee: 'document-templates/:type/options-for-employee',
  },
  jobTitles: {
    get: 'job-titles/:id',
    list: 'job-titles',
    all: 'job-titles/all',
    options: 'job-titles/options',
    create: 'job-titles',
    update: 'job-titles/:id',
    archive: 'job-titles/:id/archive',
    updateHierarchy: 'job-titles/hierarchy',
  },
  departments: {
    get: 'departments/:id',
    list: 'departments',
    options: 'departments/options',
    create: 'departments',
    update: 'departments/:id',
    delete: 'departments/:id',
  },
  documents: {
    list: 'documents',
    listForEmployee: 'documents/for-employee',
    getBreadcrumbs: 'documents/:id/breadcrumbs',
    getBreadcrumbsForEmployee: 'documents/:id/breadcrumbs-for-employee',
    downloadAsset: 'documents/:id/download',
    downloadAssetForEmployee: 'documents/:id/download-for-employee',
    folderOptions: 'documents/options/folder-options',
    typesOptions: 'documents/type-options',
    typesOptionsForEmployee: 'documents/type-options-for-employee',
    create: 'documents',
    createForEmployee: 'documents/for-employee',
    preview: 'documents/preview',
    previewForEmployee: 'documents/preview-for-employee',
    rename: 'documents/:id/rename',
  },
  tasks: {
    get: 'tasks/:id',
    list: 'tasks',
    listForUser: 'tasks/user',
    listForDocument: 'tasks/document',
    getSignAvailability: 'tasks/:id/sign-availability',
    signInitiate: 'tasks/:id/sign-initiate',
    sign: 'tasks/:id/sign',
    remind: 'tasks/:id/remind',
  },
  taskDocuments: {
    get: 'task-documents/:id',
    list: 'task-documents',
    getFile: 'task-documents/:id/file',
    updateDocumentAsRead: 'task-documents/:id/read',
  },
  employeeTimeOffs: {
    typesOptions: 'employee-time-offs/type-options',
    statusOptions: 'employee-time-offs/status-options',
  },
  globalDocumentTemplates: {
    get: 'global-document-templates/:id',
    list: 'global-document-templates',
    create: 'global-document-templates',
    update: 'global-document-templates/:id',
    delete: 'global-document-templates/:id',
    typesOptions: 'global-document-templates/type-options',
    getTypeVariables: 'global-document-templates/type-variables',
    getForAutoFill: 'global-document-templates/for-autofill',
    options: 'global-document-templates/options',
    optionsByType: 'global-document-templates/:type/options',
  },
  globalDocumentTemplateSettings: {
    get: 'global-document-template-settings/:id',
    list: 'global-document-template-settings',
    update: 'global-document-template-settings/:id',
  },
  documentTemplateSettings: {
    get: 'document-template-settings/:id',
    list: 'document-template-settings',
    update: 'document-template-settings/:id',
  },
};
